import { useState, useRef, useEffect } from 'react'
import styles from './Menu.module.css'

const Menu = ({
  onShowDisclaimer,
  onShowAbout,
  onShowChangelog,
  onShowSettings,
  showChangelog = true,
  feedbackEmail = 'aixmviewer@annea.sk',
  appName = 'App'
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef(null)

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const handleMenuItemClick = (action) => {
    setIsOpen(false)
    action()
  }

  const handleFeedback = () => {
    window.location.href = `mailto:${feedbackEmail}?subject=${appName} - Suggestions and feedback`
  }

  return (
    <div className={styles.menuContainer} ref={menuRef}>
      <button
        className={styles.menuButton}
        onClick={toggleMenu}
        aria-label="Menu"
        aria-expanded={isOpen}
      >
        &#x2630;
      </button>

      {isOpen && (
        <div className={styles.menuDropdown}>
          <button
            className={styles.menuItem}
            onClick={() => handleMenuItemClick(onShowAbout)}
          >
            About
          </button>
          {showChangelog && (
            <button
              className={styles.menuItem}
              onClick={() => handleMenuItemClick(onShowChangelog)}
            >
              Changelog
            </button>
          )}
          <button
            className={styles.menuItem}
            onClick={() => handleMenuItemClick(onShowDisclaimer)}
          >
            Disclaimer
          </button>
          {onShowSettings && (
            <button
              className={styles.menuItem}
              onClick={() => handleMenuItemClick(onShowSettings)}
            >
              Settings
            </button>
          )}
          <button
            className={styles.menuItem}
            onClick={() => handleMenuItemClick(handleFeedback)}
          >
            Suggestions and feedback
          </button>
        </div>
      )}
    </div>
  )
}

export default Menu
